import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import classnames from 'classnames';
import { Avatar } from '@pwc/appkit-react/lib/Avatar';

import Routes from '../routes';
import DropdownMenu from '../shared/dropdownMenu';
import Select from '../shared/select/select.component';
import { showUserPreferencesModal } from '../userData/store/actions';
import { clientsSelector } from '../userData/store/selectors';
import { toImageDataUrl } from '../utils/imageDataUrl';

import { UserPropTypes, ClientsPropTypes } from './shared/proptypes';
import Trigger from './trigger.component';

class UserMenu extends PureComponent {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    clients: ClientsPropTypes.isRequired,
    user: UserPropTypes,
    onMenuShow: PropTypes.func.isRequired,
    onMenuHide: PropTypes.func.isRequired,
    showUserPreferencesModal: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  };

  showUserPreferencesModal = () => {
    const { showUserPreferencesModal } = this.props;

    showUserPreferencesModal();
  };

  onClientSelect = ({ value }) => {
    this.props.history.replace(`${Routes.CHANGE_CLIENT.replace(/:clientId/, value)}`);
  };

  render() {
    // utility function to allow changing client when only one has data in DB (and, due to error, user menu is not rendered)
    window.changeTLSClient = this.onClientSelect;
    const {
      isOpen,
      clients,
      user,
      onMenuShow,
      onMenuHide,
    } = this.props;

    const lastClientId = user ? user.lastClientId : null;

    const clientsOptions = clients.map(({ clientId, name }) => ({ label: name, value: clientId }));
    const currentClient = clients.find(({ clientId }) => lastClientId === clientId);

    const userInitials = !user ? '' : `${(user.firstName || '').charAt(0)}${(user.lastName || '').charAt(0)}`;
    const userFullName = !user ? '' : `${user.firstName} ${user.lastName}`;

    return (
      <>
        <DropdownMenu
          contentClassName="user-menu-content"
          trigger={
            <Trigger active={isOpen}>
              <Avatar className="user-menu-popover-avatar" label={userInitials} />
            </Trigger>
          }
          onShow={onMenuShow}
          onHide={onMenuHide}
          openOnHover
        >
          {user && ([
            <span key="user-fullname">{userFullName}</span>,
            <button
              key="preferences-button"
              className={classnames('link-button', { 'with-separator': clients.length > 1 })}
              onClick={this.showUserPreferencesModal}
            >
              Preferences
            </button>,
            (clients.length > 1
              ? (
                <div key="clients-select-wrapper">
                  <span>Select client</span>
                  <Select
                    className="appkit-select-custom clients-select"
                    placeholder="Select client"
                    name="client"
                    value={currentClient?.clientId}
                    onChange={this.onClientSelect}
                    options={clientsOptions}
                    clearable={false}
                  />
                </div>
              ) : null
            ),
          ])}
          <Link to={Routes.LOGOUT}>Logout</Link>
        </DropdownMenu>

        {currentClient
        && <Avatar
          alt={currentClient.name}
          src={toImageDataUrl(currentClient.icon)}
          noBorder
          shape="square"
        />}
      </>
    );
  }
}

const mapStateToProps = state => ({
  clients: clientsSelector(state),
});

export default withRouter(connect(
  mapStateToProps,
  {
    showUserPreferencesModal,
  }
)(UserMenu));
